import React, { useState, useEffect } from 'react';
import { API } from "../../config";
import { isAuthenticated } from '../../store/action/auth';
import axios from 'axios';

const IntegrationCreated = props => {
    const [ connection, setConnection ] = useState(false);
    const { user, token } = isAuthenticated();

    useEffect(() => {
        _fetchData();
    }, []);
    
    const _fetchData = async () => {
        const query = new URLSearchParams(props.location.search);
        let key, name;
        if(props.match.params.name === 'jurnal') {
            name = 'jurnal';
            key = query.get('access_token');
        }
        axios.post(`${API}/v1/integrations`, {
            name:'jurnal',
            key:key
        }, {
            mode: 'cors',
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
        .then(res => {
            if(res.data.success) {
                setConnection(true)
                console.log(res.data)
            } else {
                alert(res.data.message);
            }
        })
        .catch(e => {
            console.log(e);
        })
    }


    return (
        <div className="text-center p-4 container bg-white rounded shadow">
            <div>
                <h4><i className="fas fa-check-circle mr-3 text-success"></i>Jurnal Sudah Terkoneksi</h4>
            </div>
            <br/>
            <button
                className="btn btn-primary btn-sm"
                onClick={() => window.location.assign('/integrations')}
            >
                Kembali ke menu utama
            </button>
        </div>
    )
};

export default IntegrationCreated;